import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-291be4bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-red"
}
const _hoisted_2 = { class: "flex align-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "to", -1))
const _hoisted_4 = {
  class: "flex col grow",
  style: {"width":"50vw","max-width":"400px"}
}
const _hoisted_5 = { class: "flex col grow" }
const _hoisted_6 = {
  class: "flex col grow",
  style: {"width":"500px"}
}
const _hoisted_7 = { class: "flex col" }
const _hoisted_8 = { class: "flex justify-between align-center" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = { class: "grid single" }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "main-layout" }
const _hoisted_13 = { class: "container grow" }
const _hoisted_14 = { class: "flex col grow" }
const _hoisted_15 = { class: "flex g12 justify-between wrap" }
const _hoisted_16 = { class: "flex align-center" }
const _hoisted_17 = { class: "flex align-center justify-between" }
const _hoisted_18 = { class: "edit-btn" }
const _hoisted_19 = { class: "bold" }
const _hoisted_20 = {
  class: "flex justify-end align-center",
  style: {"height":"60px"}
}
const _hoisted_21 = { class: "flex justify-between align-center" }
const _hoisted_22 = { class: "panel grow" }
const _hoisted_23 = { class: "flex justify-between" }
const _hoisted_24 = { class: "flex align-center grow" }
const _hoisted_25 = { class: "flex justify-between align-center panel grow" }
const _hoisted_26 = { class: "block-title bold f14" }
const _hoisted_27 = { class: "flex justify-between align-center panel grow" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block-title bold f14" }, " Recurrence ", -1))
const _hoisted_29 = { class: "flex justify-between" }
const _hoisted_30 = { class: "flex align-center grow" }
const _hoisted_31 = { class: "flex justify-between align-center panel grow" }
const _hoisted_32 = { class: "block-title bold f14" }
const _hoisted_33 = { class: "flex row g12 grow" }
const _hoisted_34 = { class: "panel grow flex col g12 grow" }
const _hoisted_35 = { class: "flex justify-between align-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block-title bold f14" }, "Module ", -1))
const _hoisted_37 = { class: "flex justify-between" }
const _hoisted_38 = { class: "subtitle" }
const _hoisted_39 = { class: "grid single grid-overflow" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_41 = { class: "flex justify-between" }
const _hoisted_42 = { class: "subtitle" }
const _hoisted_43 = { class: "panel grow flex col g12" }
const _hoisted_44 = { class: "flex justify-between" }
const _hoisted_45 = { class: "subtitle" }
const _hoisted_46 = { class: "grid single grid-overflow" }
const _hoisted_47 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_RRuleInput = _resolveComponent("RRuleInput")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeColorPicker = _resolveComponent("SeColorPicker")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_ElementSelectList = _resolveComponent("ElementSelectList")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_LockedField = _resolveComponent("LockedField")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_SeForm = _resolveComponent("SeForm")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeTextarea = _resolveComponent("SeTextarea")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_TaskActionList = _resolveComponent("TaskActionList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "scheduleModal",
      title: _ctx.Lang.getI18N('schedule')
    }, {
      default: _withCtx(() => [
        (_ctx.scheduleStart > _ctx.scheduleEnd)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.Lang.getI18N("schedule-incoherent")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_VDatePicker, {
            is24hr: "",
            "hide-time-header": "",
            modelValue: _ctx.scheduleStart,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scheduleStart) = $event)),
            mode: "time"
          }, null, 8, ["modelValue"]),
          _hoisted_3,
          _createVNode(_component_VDatePicker, {
            is24hr: "",
            "hide-time-header": "",
            modelValue: _ctx.scheduleEnd,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scheduleEnd) = $event)),
            mode: "time"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_SeButton, {
            class: "modal-valid",
            onPress: _ctx.addOrEditSchedule,
            icon: "/ico/edit.svg"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ok")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      ref: "modal",
      title: "Infos"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.Lang.getI18N("task-action-required")), 1)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      title: "Recurrence",
      ref: "rruleModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RRuleInput, {
          style: {"min-width":"80vw"},
          ref: "rruleInput"
        }, null, 512),
        _createVNode(_component_SeButton, {
          class: "modal-valid w100",
          onPress: _ctx.closeRRuleModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('add'),
      ref: "addActionModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SeInput, {
            ref: "actionName",
            placeholder: _ctx.Lang.getI18N('action-name')
          }, null, 8, ["placeholder"]),
          _createVNode(_component_SeButton, {
            onPress: _ctx.addAction,
            class: "modal-valid w100",
            icon: "ico/plus.svg"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("add")), 1)
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('add'),
      ref: "taskTypeModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_SeInput, {
            ref: "taskTypeName",
            placeholder: _ctx.Lang.getI18N('name')
          }, null, 8, ["placeholder"]),
          _createVNode(_component_SeColorPicker, { ref: "colorPicker" }, null, 512),
          _createVNode(_component_SeButton, {
            onPress: _ctx.modifyOrCreateTaskType,
            class: "modal-valid w100"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("apply")), 1)
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('modify'),
      ref: "modifyActionModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_SeInput, {
            ref: "actionNameMod",
            placeholder: _ctx.Lang.getI18N('action-name')
          }, null, 8, ["placeholder"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Lang.getI18N("attachments")), 1),
              _createVNode(_component_SeFadeButton, {
                onClick: _ctx.uploadAttachment,
                icon: "/ico/upload-blue.svg"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Upload")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionAttachments, (attachment) => {
                return (_openBlock(), _createBlock(_component_WideCard, {
                  icon: "/ico/link.svg",
                  highlight: true,
                  selected: true,
                  title: attachment.name
                }, {
                  subtitle: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(attachment.type), 1)
                  ]),
                  footer: _withCtx(() => [
                    _createVNode(_component_SeFadeButton, {
                      onClick: () => _ctx.moveDownAttachement(attachment),
                      icon: "/ico/arrow-minimalistic-down.svg"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_SeFadeButton, {
                      onClick: () => _ctx.moveUpAttachement(attachment),
                      icon: "/ico/arrow-minimalistic-up.svg"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_SeFadeButton, {
                      onClick: () => _ctx.downloadAttachement(attachment),
                      icon: "/ico/download.svg"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_SeFadeButton, { icon: "/ico/edit-blue.svg" }),
                    _createVNode(_component_SeFadeButton, {
                      onClick: () => _ctx.deleteAttachement(attachment),
                      icon: "/ico/trash.svg"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 256))
            ])
          ]),
          _createVNode(_component_SeButton, {
            onPress: _ctx.modifyAction,
            style: {"width":"100%"},
            icon: "ico/edit.svg",
            class: "modal-valid"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("modify")), 1)
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('modify'),
      ref: "addElementModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ElementSelectList, {
          ref: "elementSelect",
          validElements: _ctx.validElements,
          selectedElements: _ctx.selectedElements,
          module: _ctx.state.selectedModule!
        }, null, 8, ["validElements", "selectedElements", "module"]),
        _createVNode(_component_SeButton, {
          style: {"margin-top":"24px","margin-bottom":"24px","width":"100px"},
          class: "modal-valid",
          onPress: _ctx.addElements
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Ok ")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_NavHeader, {
        backButton: "true",
        title: _ctx.state.taskConfiguration!.getName()
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_SeForm, {
              ref: "submitForm",
              class: "flex g10 justify-end"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_LockedField, {
                    modelValue: _ctx.state.taskConfiguration!.name_lock,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.taskConfiguration!.name_lock) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SeInput, {
                        required: "",
                        class: "grow",
                        style: {"width":"300px","max-width":"50vw"},
                        id: "taskName",
                        placeholder: _ctx.Lang.getI18N('name'),
                        modelValue: _ctx.state.taskConfiguration!.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.taskConfiguration!.name) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_LockedField, {
                    modelValue: _ctx.state.taskConfiguration!.type_lock,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.taskConfiguration!.type_lock) = $event))
                  }, {
                    default: _withCtx(() => [
                      true
                        ? (_openBlock(), _createBlock(_component_SeDropdown, {
                            key: 0,
                            nullable: true,
                            modelValue: _ctx.state.selectedTaskType,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.selectedTaskType) = $event)),
                            titleFunc: (actionType) => actionType.name,
                            ref: "typeSelect"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.taskTypes, (taskActionType) => {
                                return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                                  displayTitle: false,
                                  value: taskActionType
                                }, {
                                  heading: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("div", {
                                        class: "color-chip",
                                        style: _normalizeStyle('background-color:' + taskActionType.color)
                                      }, null, 4),
                                      _createElementVNode("span", null, _toDisplayString(taskActionType.name), 1)
                                    ])
                                  ]),
                                  tailing: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_SeImage, {
                                        onClick: () => _ctx.openEditTaskTypeModal(taskActionType),
                                        maxWidth: 18,
                                        maxHeight: 18,
                                        src: "/ico/edit-blue.svg"
                                      }, null, 8, ["onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256)),
                              _createVNode(_component_SeDropdownItem, {
                                displayTitle: false,
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openTaskTypeModal())),
                                class: "noselect"
                              }, {
                                heading: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_19, "+ " + _toDisplayString(_ctx.Lang.getI18N("add")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "titleFunc"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 512),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_LockedField, {
                modelValue: _ctx.state.taskConfiguration!.active_lock,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.taskConfiguration!.active_lock) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ToggleSwitch, {
                    ref: "switch",
                    auto: "true",
                    modelValue: _ctx.state.taskConfiguration!.active,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.taskConfiguration!.active) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (!_ctx.state.creation)
                ? (_openBlock(), _createBlock(_component_SeButton, {
                    key: 0,
                    ref: "duplicateBtn",
                    onPress: _ctx.duplicate,
                    icon: "ico/copy.svg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("duplicate")), 1)
                    ]),
                    _: 1
                  }, 8, ["onPress"]))
                : _createCommentVNode("", true),
              _createVNode(_component_SeButton, {
                tooltip: _ctx.Lang.getI18N('save'),
                onPress: _ctx.apply,
                ref: "applyBtn",
                icon: "ico/save.svg"
              }, null, 8, ["tooltip", "onPress"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_LockedField, {
                modelValue: _ctx.state.taskConfiguration!.description_lock,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.taskConfiguration!.description_lock) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SeTextarea, {
                    placeholder: "Description",
                    id: "taskDescription",
                    modelValue: _ctx.state.taskConfiguration!.description,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.taskConfiguration!.description) = $event)),
                    defaultValue: _ctx.state.taskConfiguration!.description
                  }, null, 8, ["modelValue", "defaultValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.Lang.getI18N("notify-late")), 1),
                _createVNode(_component_LockedField, {
                  modelValue: _ctx.state.taskConfiguration!.notify_late_lock,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.taskConfiguration!.notify_late_lock) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ToggleSwitch, {
                      modelValue: _ctx.state.taskConfiguration!.notify_late,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.taskConfiguration!.notify_late) = $event)),
                      auto: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_LockedField, {
                modelValue: _ctx.state.taskConfiguration!.recurrence_lock,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.taskConfiguration!.recurrence_lock) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SeButton, {
                    icon: "/ico/edit.svg",
                    onPress: _ctx.openRRuleModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rruleText), 1)
                    ]),
                    _: 1
                  }, 8, ["onPress"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.Lang.getI18N("automatically-postponed")), 1),
                _createVNode(_component_LockedField, {
                  modelValue: _ctx.state.taskConfiguration!.automatically_postponed_lock,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.taskConfiguration!.automatically_postponed_lock) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ToggleSwitch, {
                      modelValue: _ctx.state.taskConfiguration!.automatically_postponed,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.taskConfiguration!.automatically_postponed) = $event)),
                      auto: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_ReadonlyField, {
                  locked: !_ctx.state.creation
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SeDropdown, {
                      defaultTitle: _ctx.Lang.getI18N('task-configuration.select-module')
                  ,
                      titleFunc: (value) => _ctx.Lang.getI18N(value),
                      onSelectionChanged: _ctx.onModuleChange,
                      modelValue: _ctx.state.selectedModule,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.selectedModule) = $event)),
                      ref: "module"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SeDropdownItem, {
                          value: _ctx.ModuleEnum.Temperatures
                        }, null, 8, ["value"]),
                        _createVNode(_component_SeDropdownItem, {
                          value: _ctx.ModuleEnum.Action
                        }, null, 8, ["value"]),
                        _createVNode(_component_SeDropdownItem, {
                          value: _ctx.ModuleEnum.Oils
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["defaultTitle", "titleFunc", "onSelectionChanged", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["locked"])
              ]),
              (_ctx.state.selectedModule! == _ctx.ModuleEnum.Temperatures || _ctx.state.selectedModule! == _ctx.ModuleEnum.Oils)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_LockedField, {
                        modelValue: _ctx.state.taskConfiguration!.configuration_lock,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.taskConfiguration!.configuration_lock) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.Lang.getI18N("elements")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_SeButton, {
                        onPress: _ctx.openAddElementModal,
                        icon: "/ico/edit.svg"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("modify")), 1)
                        ]),
                        _: 1
                      }, 8, ["onPress"])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedElements, (item) => {
                        return (_openBlock(), _createBlock(_component_WideCard, {
                          class: "shadow",
                          key: item.ref!.id,
                          obj: item,
                          title: item.getName(),
                          ref_for: true,
                          ref: "items",
                          icon: item.getIllustrationUrl() != null
                    ? item.getIllustrationUrl()
                    : '/ico/equipement.svg'
                    
                        }, {
                          footer: _withCtx(() => [
                            _hoisted_40
                          ]),
                          _: 2
                        }, 1032, ["obj", "title", "icon"]))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.state.selectedModule! == _ctx.ModuleEnum.Action)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_LockedField, {
                        modelValue: _ctx.state.taskConfiguration!.configuration_lock,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.taskConfiguration!.configuration_lock) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.Lang.getI18N("subtasks")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_SeButton, {
                        onPress: _ctx.openAddActionModal,
                        icon: "/ico/plus.svg"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("add")), 1)
                        ]),
                        _: 1
                      }, 8, ["onPress"])
                    ]),
                    _createVNode(_component_TaskActionList, {
                      class: "grid-overflow",
                      editClick: _ctx.openModifyActionModal,
                      deleteClick: _ctx.removeAction,
                      actions: _ctx.taskActions
                    }, null, 8, ["editClick", "deleteClick", "actions"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_LockedField, {
                  modelValue: _ctx.state.taskConfiguration!.schedule_lock,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.taskConfiguration!.schedule_lock) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.Lang.getI18N("schedule")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_SeButton, {
                  onPress: _ctx.openAddScheduleModal,
                  icon: "/ico/plus.svg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("add")), 1)
                  ]),
                  _: 1
                }, 8, ["onPress"])
              ]),
              _createElementVNode("div", _hoisted_46, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schedules, (schedule) => {
                  return (_openBlock(), _createBlock(_component_WideCard, {
                    class: "shadow",
                    key: schedule.start,
                    obj: schedule,
                    title: _ctx.Lang.getI18N('schedule'),
                    icon: "/ico/calendar.svg",
                    onClick: ($event: any) => (_ctx.openEditScheduleModal(schedule))
                  }, {
                    body: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.dateFormat(
                        _ctx.DateUtils.getDateFromMinutes(schedule.start - 60),
                        "HH:MM"
                      )) + " - " + _toDisplayString(_ctx.dateFormat(
                          _ctx.DateUtils.getDateFromMinutes(schedule.end - 60),
                          "HH:MM"
                        )), 1)
                      ])
                    ]),
                    footer: _withCtx(() => [
                      _createVNode(_component_SeFadeButton, {
                        onClick: [
                          _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"])),
                          ($event: any) => (_ctx.removeSchedule(schedule))
                        ],
                        icon: "/ico/trash.svg",
                        text: "Delete"
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["obj", "title", "onClick"]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}